'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const typeUtils_1 = require('../../util/typeUtils');
const scalars_1 = require('../schema/scalars');
const types_1 = require('./types');
const validateTextField = value => {
    if (typeof value !== 'string') {
        return {
            isValid: false,
            error: types_1.ValidationError.InvalidValueType
        };
    }
    return { isValid: true };
};
const validateBooleanField = value => {
    if (typeof value !== 'boolean') {
        return {
            isValid: false,
            error: types_1.ValidationError.InvalidValueType
        };
    }
    return { isValid: true };
};
const validateNumberField = value => {
    if (typeof value !== 'number') {
        return {
            isValid: false,
            error: types_1.ValidationError.InvalidValueType
        };
    }
    return { isValid: true };
};
const scalarValidators = {
    [scalars_1.VLContentScalars.VLText]: validateTextField,
    [scalars_1.VLContentScalars.VLLongText]: validateTextField,
    [scalars_1.VLContentScalars.VLDate]: validateTextField,
    [scalars_1.VLContentScalars.VLDateTime]: validateTextField,
    [scalars_1.VLContentScalars.VLBoolean]: validateBooleanField,
    [scalars_1.VLContentScalars.VLNumber]: validateNumberField
};
exports.default = (field, value, parentTypeComposer) => {
    const fieldType = parentTypeComposer.getFieldTC(field).getTypeName();
    const vlScalarType = scalars_1.VLContentScalars[fieldType];
    if (!vlScalarType) {
        return {
            isValid: false,
            error: types_1.ValidationError.InvalidSchemaType
        };
    }
    if (parentTypeComposer.isFieldNonNull(field) && !typeUtils_1.isDefined(value)) {
        return {
            isValid: false,
            error: types_1.ValidationError.MissingRequiredValue
        };
    }
    const scalarValidationResult = scalarValidators[vlScalarType](value);
    if (typeUtils_1.isDefined(value) && !scalarValidationResult.isValid) {
        return scalarValidationResult;
    }
    return { isValid: true };
};    //# sourceMappingURL=data:application/json;base64,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
